import axios from './axios.service';

export default class Categories {
  /**
   *  List affilaite categories
   * @param {Object} filters
   * @returns promise
   */
  static listCategories(filters) {
    return axios.get('/api/v2/cmt-backend/merchants/categories/affiliate', {
      params: { ...filters },
    });
  }

  /**
   * Create affilaite category
   * @param {Object} category
   * @returns promise
   */
  static createCategory(category) {
    return axios.post(
      '/api/v2/cmt-backend/merchants/categories/affiliate',
      category,
    );
  }

  /**
   * Update affilaite category
   * @param {Number} id
   * @param {Object} category
   * @returns promise
   */
  static updateCategory(id, category) {
    return axios.put(
      `/api/v2/cmt-backend/merchants/categories/affiliate/${id}`,
      category,
    );
  }

  /**
   * Fetch affilaite category
   * @param {Number} id
   * @returns promise
   */
  static getCategory(id) {
    return axios.get(
      `/api/v2/cmt-backend/merchants/categories/affiliate/${id}`,
    );
  }

  /**
   * Delete affilaite category
   * @param {Number} id
   * @returns promise
   */
  static deleteCategory(id) {
    return axios.delete(
      `/api/v2/cmt-backend/merchants/categories/affiliate/${id}`,
    );
  }
}
